export default __webpack_public_path__ + "ee70161ccf94341c3a5a69c3c59ba025.png";